<!-- Video: her zaman DOM'da — anında oynar -->
<video #idleVideo class="idle-video-sabit" src="assets/Uyar/videos/uyar-intro.mp4"
       autoplay loop muted playsinline preload="auto"></video>

<!-- IDLE: Sinematik bilgi slaytları -->
<div class="idle-icerik">
  <div class="sag-slider"
       (touchstart)="swipeBasla($event)"
       (touchend)="swipeBitir($event)"
       (mousedown)="swipeMouseBasla($event)"
       (mouseup)="swipeMouseBitir($event)">

    @if (aktifSlide === 0) {
    <!-- SLIDE: Son Giriş Yapanlar -->
    <div class="sag-slide slide-crossfade">
      <div class="slide-son-girisler">
        <div class="slide-bg-particles">
          <span class="particle"></span><span class="particle"></span><span class="particle"></span>
          <span class="particle"></span><span class="particle"></span><span class="particle"></span>
        </div>
        <div class="slide-son-girisler-baslik">
          <span class="son-giris-ikon">🕐</span>
          <span>Son Giriş Yapanlar</span>
        </div>
        @if (durum.sonGirisler().length) {
          <div class="slide-son-girisler-liste">
            @for (g of durum.sonGirisler(); track g.isim + g.saat; let i = $index) {
              <div class="son-giris-item" [style.animation-delay]="(i * 0.1) + 's'">
                <div class="son-giris-avatar">
                  @if (g.resimUrl) {
                    <img [src]="g.resimUrl" alt="" />
                  } @else {
                    <span>{{ g.isim?.[0] || '?' }}</span>
                  }
                </div>
                <div class="son-giris-bilgi">
                  <div class="son-giris-isim">{{ g.isim }} {{ g.soyisim }}</div>
                  <div class="son-giris-rol">{{ g.rol }}</div>
                </div>
                <div class="son-giris-saat">{{ g.saat }}</div>
              </div>
            }
          </div>
        } @else {
          <div class="slide-son-girisler-bos">
            <div class="son-giris-bos-ikon">📡</div>
            <div class="son-giris-bos-yazi">Henüz giriş kaydı yok</div>
            <div class="son-giris-bos-alt">Kartınızı okutarak giriş yapın</div>
          </div>
        }
      </div>
    </div>
    }

    @if (aktifSlide === 1) {
    <!-- SLIDE: İş Kazasız Günler -->
    <div class="sag-slide slide-crossfade">
      <div class="slide-guvenlik">
        <div class="slide-guvenlik-shield">
          <div class="shield-ring r1"></div>
          <div class="shield-ring r2"></div>
          <div class="shield-ring r3"></div>
          <span class="shield-ikon">🛡️</span>
        </div>
        <div class="slide-guvenlik-baslik">İş Kazasız Günler</div>
        <div class="slide-guvenlik-counter">
          <span class="counter-num">{{ animKazasizGun }}</span>
          <span class="counter-unit">GÜN</span>
        </div>
        <div class="slide-guvenlik-mesaj">Güvenli çalışmaya devam! Hep birlikte başarıyoruz.</div>
        <div class="slide-guvenlik-progress">
          <div class="gp-track">
            <div class="gp-fill" style="width: 71%"></div>
          </div>
          <span class="gp-label">Hedef: 200 gün</span>
        </div>
      </div>
    </div>
    }

    @if (aktifSlide === 2) {
    <!-- SLIDE: Üretim Performansı -->
    <div class="sag-slide slide-crossfade">
      <div class="slide-uretim">
        <div class="slide-uretim-baslik">📊 Üretim Performansı</div>
        <div class="slide-uretim-grid">
          @for (stat of istatistikler; track stat.baslik; let i = $index) {
          <div class="slide-uretim-kart" [style.animation-delay]="(i * 0.12) + 's'">
            <div class="slide-uretim-deger">{{ animasyonSayac[i] | number }}</div>
            <div class="slide-uretim-etiket">{{ stat.baslik }}</div>
            <div class="slide-uretim-alt">{{ stat.alt }}</div>
          </div>
          }
        </div>
        <div class="slide-uretim-gauge-wrap">
          <div class="gauge-container">
            <svg viewBox="0 0 120 120" class="gauge-svg">
              <circle cx="60" cy="60" r="50" stroke-width="10" fill="none" class="gauge-bg"/>
              <circle cx="60" cy="60" r="50" stroke-width="10" fill="none" class="gauge-fill"
                stroke-dasharray="314" [attr.stroke-dashoffset]="314 - (314 * animGaugeYuzde / 100)"/>
            </svg>
            <div class="gauge-center">
              <span class="gauge-num">{{ animGaugeYuzde }}</span>
              <span class="gauge-pct">%</span>
            </div>
          </div>
          <div class="gauge-label">Genel Verimlilik</div>
        </div>
      </div>
    </div>
    }

    @if (aktifSlide === 3) {
    <!-- SLIDE: Duyurular -->
    <div class="sag-slide slide-crossfade">
      <div class="slide-duyuru">
        <div class="slide-duyuru-header">
          <span class="slide-duyuru-ikon">📢</span>
          <span class="slide-duyuru-baslik">Duyurular</span>
        </div>
        <div class="slide-duyuru-list">
          <div class="slide-duyuru-item duyuru-anim" style="animation-delay: 0s">
            <div class="duyuru-dot acil"></div>
            <div class="duyuru-body">
              <div class="duyuru-text">Yarın 09:00'da genel toplantı yapılacaktır. Tüm personelin katılması beklenmektedir.</div>
              <div class="duyuru-meta">2 saat önce &middot; Yönetim</div>
            </div>
          </div>
          <div class="slide-duyuru-item duyuru-anim" style="animation-delay: 0.15s">
            <div class="duyuru-dot bilgi"></div>
            <div class="duyuru-body">
              <div class="duyuru-text">CNC-003 tezgahı bakım tamamlandı, üretime hazır durumda.</div>
              <div class="duyuru-meta">5 saat önce &middot; Bakım</div>
            </div>
          </div>
          <div class="slide-duyuru-item duyuru-anim" style="animation-delay: 0.3s">
            <div class="duyuru-dot basari"></div>
            <div class="duyuru-body">
              <div class="duyuru-text">Mart ayı üretim hedefi %80 seviyesine ulaştı! Tebrikler.</div>
              <div class="duyuru-meta">1 gün önce &middot; Üretim</div>
            </div>
          </div>
          <div class="slide-duyuru-item duyuru-anim" style="animation-delay: 0.45s">
            <div class="duyuru-dot bilgi"></div>
            <div class="duyuru-body">
              <div class="duyuru-text">Yeni iş güvenliği eğitimi Cuma günü başlayacaktır.</div>
              <div class="duyuru-meta">2 gün önce &middot; İK</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }

    @if (aktifSlide === 4) {
    <!-- SLIDE: Tezgah Durumu -->
    <div class="sag-slide slide-crossfade">
      <div class="slide-tezgah">
        <div class="slide-tezgah-baslik">⚙️ Tezgah Durumu</div>
        <div class="slide-tezgah-ozet">
          <div class="tezgah-ozet-item yesil-bg">
            <span class="tezgah-ozet-sayi">{{ animTezgahCalisanSayi }}</span>
            <span class="tezgah-ozet-etiket">Çalışıyor</span>
          </div>
          <div class="tezgah-ozet-item turuncu-bg">
            <span class="tezgah-ozet-sayi">{{ animTezgahBostaSayi }}</span>
            <span class="tezgah-ozet-etiket">Boşta</span>
          </div>
          <div class="tezgah-ozet-item kirmizi-bg">
            <span class="tezgah-ozet-sayi">{{ animTezgahBakimSayi }}</span>
            <span class="tezgah-ozet-etiket">Bakımda</span>
          </div>
        </div>
        <div class="slide-tezgah-grid">
          @for (t of tezgahlar; track t.ad; let i = $index) {
          <div class="tezgah-kart"
               [class.calisiyor]="t.durum === 'calisiyor'"
               [class.bosta]="t.durum === 'bosta'"
               [class.bakim]="t.durum === 'bakim'"
               [style.animation-delay]="(i * 0.08) + 's'">
            <div class="tezgah-led" [style.background]="tezgahDurumRenk(t.durum)"></div>
            <div class="tezgah-ad">{{ t.ad }}</div>
            <div class="tezgah-operasyon">{{ t.operasyon }}</div>
            <div class="tezgah-durum-yazi">{{ tezgahDurumYazi(t.durum) }}</div>
            @if (t.durum === 'calisiyor') {
            <div class="tezgah-bar">
              <div class="tezgah-bar-fill" [style.width.%]="t.yuzde"></div>
            </div>
            <div class="tezgah-yuzde">%{{ t.yuzde }}</div>
            }
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Slide navigasyon noktaları -->
    <div class="sag-slide-nav">
      @for (s of [0,1,2,3,4]; track s) {
      <span class="sag-slide-dot" [class.aktif]="aktifSlide === s" (click)="slideGit(s)"></span>
      }
    </div>
  </div>
</div>
